import { BaseRequestModel } from '../../../base/base.request.model';
import { ProductAppChannelModel } from '../../../products/model/product-app-channel-model.model';

export class GetVODCatalogRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetVODCatalogRequestMessage!: VODCatalogRequestMessageModel;
}

export class VODCatalogRequestMessageModel extends BaseRequestModel {
  // returnAppChannels?: string;
  appChannels?: ProductAppChannelModel;
  // returnLocaleDisplayName?: string;
  returnPromotions?: string;
  returnAttributes?: string;
  rateType?: string;
  salesChannel?: string;
}
